export type DocType =
	| 'prescription'
	| 'receipt'
	| 'other'
	| 'complaint'
	| 'fraud';

export enum UploadFileStep {
	CHOOSE = 'CHOOSE',
	LOADING = 'LOADING',
	COMPLETE = 'COMPLETE',
}

export interface IUploadState {
	prescription?: IPrescription;
	attestation?: IAttestation;
	receipt?: IReceipt;
	step: UploadFileStep;
	uploadPercentage: number;
	errorCode: number;
	errorMessage: string;
	documentTypeSelected: DocType;
	file: File | null;
	filePromise: any;
	documentId: number | null;
}

export interface IPrescription {
	prescriptionId: number;
	fileName: string;
	resourceUrl: string;
}

export interface IAttestation {
	attestationId: number;
	fileName: string;
	resourceUrl: string;
}

export interface IReceipt {
	receiptId: number;
	fileName: string;
	resourceUrl: string;
}

export interface IUploadedFileResponse {
	uuid: string;
	fileName: string;
}

export type iFile = 'fromLibrary' | 'fromPhoto' | 'fromFile';

export interface IUploadAction {
	icon: string;
	label: string;
	actionType: iFile;
}
